import { Box } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { SystemRoundedCheckbox } from "@/ui/Clickable/SystemRoundedCheckbox";
import { InlineHint } from "@/ui/molecules/InlineHint";

type Props = {
	/** The acknowledgement as the wrapped hook holds it — for a single removal that needs one, `deleteValid` IS it. */
	isAcknowledged: boolean;
	onAcknowledgedChange: (next: boolean) => void;
	testIdPrefix: string;
};

/** The payroll warning a removal from an already-paid period needs, and its acknowledgement, which gates the confirm. */
export const GapsRemovalPayrollAck: FC<Props> = ({ isAcknowledged, onAcknowledgedChange, testIdPrefix }) => {
	const { t } = useTranslation();
	return (
		<Box data-testid={`${testIdPrefix}-payroll`} sx={{ display: "flex", flexDirection: "column", gap: 0.75 }}>
			<InlineHint open tone="warning">
				{t("gaps.callIn.removal.payrollBody")}
			</InlineHint>
			<SystemRoundedCheckbox
				checked={isAcknowledged}
				onChange={onAcknowledgedChange}
				label={t("gaps.callIn.removal.payrollAck")}
				data-testid={`${testIdPrefix}-payroll-ack`}
			/>
		</Box>
	);
};
